var map = {
	"./DonationQRCode/index.jsx": 592,
	"./EventEarnings/index.jsx": 594,
	"./ItemRotator/index.jsx": 601,
	"./ItemsQRCode/index.jsx": 613,
	"./ScrollingShoutouts/index.jsx": 615,
	"./Shoutouts/index.jsx": 619
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 591;


//////////////////
// WEBPACK FOOTER
// ./src/components/Template/Blocks ^\.\/[\w]+\/index\.(jsx?)$/i
// module id = 591
// module chunks = 0